export const tenantConfig = {
  mosqueName: "Masjid Raya",
  tagline: "Memakmurkan Masjid, Memberdayakan Umat",
  logo: "https://images.pexels.com/photos/36830566/pexels-photo-36830566.jpeg",
  
  colors: {
    primary: "#065F46",
    primaryLight: "#10B981",
    primaryDark: "#022C22",
    accent: "#D4AF37",
    accentLight: "#FBBF24"
  },
  
  location: {
    city: "Jakarta",
    country: "Indonesia",
    address: "Jl. Masjid Raya No. 123, Jakarta Pusat"
  },
  
  contact: {
    phone: "+62 812-3456-7890",
    email: "info@masjidraya.com",
    whatsapp: "6281234567890"
  },
  
  social: {
    facebook: "https://facebook.com/masjidraya",
    instagram: "https://instagram.com/masjidraya",
    youtube: "https://youtube.com/@masjidraya"
  },
  
  streaming: {
    makkah: "https://www.youtube.com/embed/FQBNhNL0OWU",
    madinah: "https://www.youtube.com/embed/yOFfjekGiye"
  }
};

export default tenantConfig;